import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { History } from 'history';

// * import reducers here
import { appGlobals } from './app-globals/reducer';
import { cooksProfile } from './cooksprofile/reducer';
import { mealReducers } from './meals/reducer';
import { userReducer } from './user/reducer';
import { orderReducer } from './orders/reducer';
import { settingsReducer } from './settings/reducer';
import { chatReducer } from './chat/reducer';
import { adminReducer } from './admin/reducer';
import { notificationReducer } from './notifications/reducer';
import { paymentReducer } from './bank/reducer';
import { paymentCustomerReducer } from './payment/reducer';

export const createRootReducer = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    appGlobals,
    cooksProfile,
    mealReducers,
    userReducer,
    orderReducer,
    settingsReducer,
    chatReducer,
    adminReducer,
    notificationReducer,
    paymentReducer,
    paymentCustomerReducer,
  });

export type RootReducer = ReturnType<typeof createRootReducer>;
